import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api/client.js';

const S = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--bone)',
    padding: 24,
  },
  card: {
    background: 'var(--white)',
    padding: '48px 40px',
    maxWidth: 400,
    width: '100%',
    border: '1px solid rgba(139,115,85,.18)',
  },
  title: {
    fontFamily: 'var(--wordmark)',
    fontSize: 22,
    letterSpacing: '.18em',
    fontWeight: 500,
    textAlign: 'center',
    marginBottom: 8,
  },
  subtitle: {
    fontFamily: 'var(--label)',
    fontSize: 11,
    letterSpacing: '.3em',
    textTransform: 'uppercase',
    color: 'var(--bronze)',
    textAlign: 'center',
    marginBottom: 36,
  },
  label: {
    fontFamily: 'var(--label)',
    fontSize: 11,
    letterSpacing: '.2em',
    textTransform: 'uppercase',
    display: 'block',
    marginBottom: 6,
    color: 'var(--slate-70)',
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    border: '1px solid var(--bronze-30)',
    background: 'var(--bone-soft)',
    fontFamily: 'var(--body)',
    fontSize: 17,
    color: 'var(--slate)',
    outline: 'none',
    marginBottom: 20,
  },
  btn: {
    width: '100%',
    padding: '14px',
    background: 'var(--slate)',
    color: 'var(--bone)',
    border: 0,
    fontFamily: 'var(--label)',
    fontSize: 12,
    letterSpacing: '.28em',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
  error: {
    color: '#c44',
    fontFamily: 'var(--label)',
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 16,
  },
};

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const json = await api.login(username, password);
      localStorage.setItem('token', json.token);
      navigate('/admin');
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <form onSubmit={handleSubmit}>
          <div style={S.title}>DEXON LEGAL</div>
          <div style={S.subtitle}>Administration</div>
          {error && <div style={S.error}>{error}</div>}
          <label style={S.label}>Username</label>
          <input style={S.input} value={username} onChange={e => setUsername(e.target.value)} autoFocus />
          <label style={S.label}>Password</label>
          <input style={S.input} type="password" value={password} onChange={e => setPassword(e.target.value)} />
          <button style={S.btn} type="submit">Sign in</button>
        </form>
      </div>
    </div>
  );
}
